import React from 'react'
import TopHeading from './TopHeading'
import image1 from "../assets/Images/portfolio/Capture.PNG"
import image2 from "../assets/Images/portfolio/Capture1.PNG"
import image3 from "../assets/Images/portfolio/Capture4.PNG"
import image4 from "../assets/Images/portfolio/Capture3.PNG"



const Portfolio = () => {

    return (
        <>
            <section className='py-5' id='portfolio'>
                <div className='auto-container py-md-5'>
                    <div className='row'>
                        <div>
                            <TopHeading head={'Portfolio'} title={'Checkout Our Portfolio.'} />
                        </div>

                        <div className='mt-5'>
                            <div className='row'>
                                <div className='col-md-8 mb-4 '>
                                    <img src={image1} alt="portfolio_image 2" className='portfolio_img' loading="lazy" />
                                </div>
                                <div className='col-md-4 mb-4'>
                                    <img src={image2} alt="portfolio_image 1" className='portfolio_img' loading="lazy" />
                                </div>
                               
                                {/* <div className='col-md-4 mb-4'>
                                    <img src={image3} alt="portfolio_image 3" className='portfolio_img' loading="lazy" />
                                </div> */}
                                <div className='col-md-4 mb-4'>
                                    <img src={image3} alt="portfolio_image 4" className='portfolio_img' loading="lazy" />
                                </div>
                                <div className='col-md-8 mb-4'>
                                    <img src={image4} alt="portfolio_image 5" className='portfolio_img' loading="lazy" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}


export default Portfolio